import actionTypes from 'SRC/modules/redux/actionTypes'

export const setProfileLoading = isLoading => ({
  type: actionTypes.SET_PROFILE_LOADING,
  payload: Boolean(isLoading)
})
